"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var React=require("react"),a=require("styled-components"),fonts=require("../fonts.js");function _interopDefaultLegacy(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var React__default=_interopDefaultLegacy(React);let e=a.createGlobalStyle`
  @font-face {
    font-family: "CircularXXWeb-Bold";
    src: url(${fonts.CircularXXWebBold}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Book";
    src: url(${fonts.CircularXXWebBook}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Medium";
    src: url(${fonts.CircularXXWebMedium}) format("woff");
  }

  /* Ripple declares 'CircularXX', sans-serif. These faces give that family
     the same files as above, by weight, so Ripple renders in Circular XX
     without a second copy of the font. */
  @font-face {
    font-family: "CircularXX";
    font-weight: 400;
    src: url(${fonts.CircularXXWebBook}) format("woff");
  }

  @font-face {
    font-family: "CircularXX";
    font-weight: 500;
    src: url(${fonts.CircularXXWebMedium}) format("woff");
  }

  @font-face {
    font-family: "CircularXX";
    font-weight: 700;
    src: url(${fonts.CircularXXWebBold}) format("woff");
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${({theme:t})=>t.typography.fontFamily};
  }

  body.fontLoaded {
    font-family: ${({theme:t})=>`'Lato', ${t.typography.fontFamily}`};
  }
`;const GlobalStyle=({...t})=>React__default.default.createElement(e,t);exports.GlobalStyle=GlobalStyle;
//# sourceMappingURL=GlobalStyle.js.map
